import { Route42InlineMarkdown, Route42Markdown } from '../../../components/ui/Route42Markdown';
import { ROUTE42_ASSISTANT_NAME } from '../../../config/identity';
import type { ConversationTurnDto } from '../types/conversation';
import { deriveEvidenceStrength } from '../types/conversation';
import { formatThreadTimestamp, formatThreadTimestampTitle } from '../utils/thread-time';

export function ConversationTurn({ turn, onEvidence, onInvestigate }: { turn: ConversationTurnDto; onEvidence: () => void; onInvestigate?: () => void }) {
  const answer = turn.answer;
  return (
    <article className="r42-turn" data-testid="conversation-turn">
      <div className="r42-turn__user"><div className="r42-turn-meta r42-turn-meta--user"><span className="r42-turn-label">You</span>{turn.created_at ? <time dateTime={turn.created_at} title={formatThreadTimestampTitle(turn.created_at)}>{formatThreadTimestamp(turn.created_at)}</time> : null}</div><p>{turn.question}</p></div>
      {answer ? (
        <div className="r42-turn__assistant">
          <span className="r42-turn-label">{ROUTE42_ASSISTANT_NAME}</span>
          <Route42Markdown className="r42-answer-text" content={answer.answer_text} />
          {isIndustrialGuidance(answer.knowledge_basis) ? (
            <div className="r42-answer-basis" aria-label="Answer knowledge basis">
              <span>{answer.knowledge_basis === 'CONTEXTUAL_INDUSTRIAL_GUIDANCE' ? 'Industrial guidance · current work context' : 'General industrial guidance'}</span>
              <p>{answer.knowledge_basis === 'CONTEXTUAL_INDUSTRIAL_GUIDANCE' ? 'Ace can use the work context you are in, but this is not a conclusion about the machine.' : 'This answer uses general industrial knowledge, not evidence from this machine.'}</p>
            </div>
          ) : answer.knowledge_basis === 'OUT_OF_SCOPE' ? null : (
            <div className="r42-answer-meta">
              <span className={`r42-answer-strength r42-answer-strength--${deriveEvidenceStrength(answer).toLocaleLowerCase()}`}>{humanize(deriveEvidenceStrength(answer))} evidence</span>
              {answer.conflicting_evidence ? <span className="r42-answer-conflict">Conflicting evidence</span> : null}
              {(answer.citations?.length ?? 0) > 0 ? <button onClick={onEvidence}>View evidence <span>{answer.citations.length}</span></button> : null}
              {onInvestigate ? <button className="r42-investigate-answer" onClick={onInvestigate}><i className="bi bi-search" aria-hidden="true" /> Investigate</button> : null}
            </div>
          )}
          {answer.uncertainty ? <p className="r42-answer-uncertainty"><strong>Uncertainty:</strong> <Route42InlineMarkdown content={answer.uncertainty} /></p> : null}
        </div>
      ) : null}
    </article>
  );
}

function isIndustrialGuidance(value: string | null | undefined): boolean {
  return value === 'GENERAL_INDUSTRIAL_KNOWLEDGE' || value === 'CONTEXTUAL_INDUSTRIAL_GUIDANCE';
}

function humanize(value: string): string {
  return value.toLocaleLowerCase().replace(/^./, (char) => char.toLocaleUpperCase());
}
